<template>
  <div>

    <el-divider content-position="left">İşletme Projesi Detay</el-divider>
    <el-form ref="Form">

      <hr v-if="ProjeDetay">
      <el-row :gutter="24">
        <el-col :span="6">
          <el-row :gutter="24" v-if="AltToplam.Aylik">
            <mWidget
              :data="{isim: 'Aylık tahmini gider', sayi: AltToplam.Aylik, icon: 'el-icon-upload2', renk: 'ins1 m-widget-mini'}"></mWidget>
            <mWidget
              :data="{isim: 'Dönem sonu tahmini gider', sayi: AltToplam.Donem, icon: 'el-icon-s-claim', renk: 'ins2 m-widget-mini'}"></mWidget>
            <mWidget
              :data="{isim: Adet+' Meskene göre maaliyet', sayi: AltToplam.Mesken, icon: 'el-icon-s-claim', renk: 'ins3 m-widget-mini'}"></mWidget>
            <mWidget
              :data="{isim: Toplam+' M2ye göre maaliyet', sayi: AltToplam.M2, icon: 'el-icon-s-claim', renk: 'ins4 m-widget-mini'}"></mWidget>
          </el-row>
        </el-col>
        <el-col :span="18">
          <el-row :gutter="24">
            <el-col :span="9">
              <el-form-item label="Kategori" prop="Kategori_id">
                <el-cascader
                  :options="Kategoriler"
                  v-model="Form.Kategori_id"
                  collapse-tags
                  filterable></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item label="Tahmini Aylık Bütçe" prop="Tutar">
                <el-input v-model="Form.Tutar"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button @click="Ekle" :disabled="!Form.Kategori_id" class="btn-block mt-4" size="small"
                         type="success"><i
                class="el-icon-plus"></i> Ekle
              </el-button>
            </el-col>
          </el-row>
          <el-row v-for="(p,index) in ProjeDetay" :gutter="24">
            <el-col :span="9">
              <el-form-item label="Kategori" prop="Kategori_id">
                <el-cascader
                  :options="Kategoriler"
                  v-model="p.Kategori_id"
                  collapse-tags
                  filterable></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item label="Tahmini Aylık Bütçe" prop="Tutar">
                <el-input @change="Hesapla" v-model="p.Tutar"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button @click="Cikar(index)" class="btn-block mt-4" size="small"
                         type="danger"><i
                class="el-icon-minus"></i> Çıkar
              </el-button>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  import mWidget from "./mWidget";

  export default {
    components: {mWidget},
    props: ["Adet", "Toplam", "Sure", "Proje"],
    data() {
      return {
        DaireAdet: 0,
        DaireM2: 0,
        Tur: false,
        Kategoriler: null,
        ProjeDetay: [],
        Form: {
          Kategori_id: null,
          Tutar: 0,
        },
        AltToplam: {
          Aylik: 0,
          Donem: 0,
          Mesken: 0,
          M2: 0
        }
      }
    },
    methods: {
      Cikar(index) {
        this.ProjeDetay.splice(index, 1);
        this.Hesapla();
      },
      Ekle() {
        this.ProjeDetay.push({
          Kategori_id: this.Form.Kategori_id,
          Tutar: this.Form.Tutar,
        });
        this.Form = {
          Kategori_id: null,
          Tutar: 0,
        };
        this.Hesapla();
      },
      Hesapla() {
        this.AltToplam.Aylik = 0;
        this.ProjeDetay.forEach((data, index) => {
          this.AltToplam.Aylik += Number(data.Tutar);
        });
        this.AltToplam.Aylik = this.AltToplam.Aylik.toFixed(2);
        this.AltToplam.Donem = (this.AltToplam.Aylik * this.Sure).toFixed(2);
        this.AltToplam.Mesken = Number(this.AltToplam.Aylik / this.Adet).toFixed(2)
        this.AltToplam.M2 = Number(this.AltToplam.Aylik / this.Toplam).toFixed(2)
        this.$emit('Proje', this.ProjeDetay);
      },
      SayfaYukle() {
        this.AltToplam = {
          Aylik: 0,
          Donem: 0,
          Mesken: 0,
          M2: 0
        };
        this.ProjeDetay = this.Proje;
        if(!this.ProjeDetay) this.ProjeDetay=[];
        this.Hesapla();
      },

    },
    created() {
      if (this.Proje) this.ProjeDetay = this.Proje; else this.ProjeDetay = []
      this.$store.dispatch("Get", {path: 'muhasebe/kategori'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Kategoriler = response.Liste
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
      this.Hesapla();
    },
    computed: {
      rSAyfaYukle() {
        return this.Proje
      },
    },
    watch: {
      rSAyfaYukle() {
        this.SayfaYukle();
      },
    }
  }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Genel/IsletmeProjesi.vue